import { useState, useEffect } from "react";
import { getobj, dltobj } from "../../apicall/apicall";
import {
  boxStyle,
  StyledTableCell,
  StyledTableRow,
} from "../../style/style";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Box, Button } from "@mui/material";

import Pagination from "@mui/material/Pagination";

import "react-notifications/lib/notifications.css";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

export default function DistributorUserList(props) {
  const [loaded, setloaded] = useState(true);
  const [orgs, setorgs] = useState([]);
  const [page, setpage] = useState(1);
  const [pagetotal, setpaget] = useState();
  const handlePagechange = (event, value) => {
    setloaded(true);
    setpage(value);
    const url =
      process.env.REACT_APP_ZEWA_URL +
      "distributor/add-org/?id=" +
      props.id +
      "&page=" +
      value +
      "&role=DISTRIBUTOR-USER";
    const res = getobj(url);
    res.then(function (res) {
      setorgs(res.results);
      setloaded(false);
    });
  };
  const handleDelete = (id) => {
    const data = { id: id };
    console.log(data);
    const url = process.env.REACT_APP_ZEWA_URL + "user/add/0/";
    const res = dltobj(url, data);
    res
      .then((res) => {
        if (res.status === 200) {
          return res;
        }
        throw new Error(res);
      })
      .then(() => {
        NotificationManager.remove(NotificationManager.listNotify[0]);

        NotificationManager.success("User deleted Successfully");
        props.setrefresh(!props.refresh);
        // props.setrefresh(true);
      })
      .catch(() => NotificationManager.Error("Something went wrong"));
  };
  useEffect(() => {
    if (props.search.search !== "") {
      const url =
        process.env.REACT_APP_ZEWA_URL +
        "distributor/search_org_and_user/?role=DISTRIBUTOR-USER&distributor_id=" +
        props.id +
        "&search=" +
        props.search.search;
      const res = getobj(url);
      res.then(function (res) {
        if (res.results.length > 0) {
          setorgs(res.results);
          console.log(res);
          if (res.count % res.results.length > 0) {
            setpaget(Math.floor(res.count / res.results.length) + 1);
          } else {
            setpaget(Math.floor(res.count / res.results.length));
          }
        }
        setloaded(false);
      });
    } else {
      const url =
        process.env.REACT_APP_ZEWA_URL +
        "distributor/add-org/?id=" +
        props.id +
        "&role=DISTRIBUTOR-USER";
      const res = getobj(url);
      res.then(function (res) {
        setorgs(res.results);
        console.log(res);
        if (res.count % 5 > 0) {
          setpaget(Math.floor(res.count / 5) + 1);
        } else {
          setpaget(Math.floor(res.count / 5));
        }
        setloaded(false);
      });
    }
  }, [props.refresh, props.search_refresh, props.search.search, props.id]);
  return (
    <div style={boxStyle}>
      {loaded ? (
        <img src="https://zewa-logo-bucket.s3.amazonaws.com/logo/Spinner-1s-200px.gif" alt="loading..." />
      ) : (
        <Box>
          {orgs.length > 0 ? (
            <TableContainer>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>
                      <b>Company Name</b>
                    </StyledTableCell>
                    <StyledTableCell>
                      <b>Name</b>
                    </StyledTableCell>
                    <StyledTableCell>
                      <b>Email</b>
                    </StyledTableCell>
                    <StyledTableCell>
                      <b>Phone</b>
                    </StyledTableCell>

                    <StyledTableCell></StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orgs.length > 0 &&
                    orgs.map((user) => (
                      <StyledTableRow key={user.id}>
                        <StyledTableCell>{user.company_name}</StyledTableCell>

                        <StyledTableCell>
                          {user.customer_id["first_name"] +
                            " " +
                            user.customer_id["last_name"]}
                        </StyledTableCell>
                        <StyledTableCell>
                          {user.customer_id["email"]}
                        </StyledTableCell>
                        <StyledTableCell>
                          {user.customer_id["phone_number"]}
                        </StyledTableCell>
                        <StyledTableCell
                          onClick={() => {
                            handleDelete(user.customer_id["id"]);
                          }}
                        >
                          <Button variant="contained" color="error">
                            Remove
                          </Button>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                </TableBody>
              </Table>
              <Pagination
                count={pagetotal}
                page={page}
                variant="outlined"
                color="primary"
                onChange={handlePagechange}
              />
            </TableContainer>
          ) : (
            <h3>No User added yet</h3>
          )}
        </Box>
      )}
      <NotificationContainer />
    </div>
  );
}
